import { ReactElement, useMemo, memo } from 'react';

import { PartnerCompanyTypes } from '~globals/types/enums';
import { Nullable } from '~globals/types/commons';
import { useAppSelector } from '~hooks/useAppSelector';
import { selectAuth } from '~store/slices/auth/index';
import { validatePartnerCompanyType } from '~utils/partnerCompany';

import { IntegrationsSectionStoresCardProps } from './types';
import {
  IntegrationsSectionStoresCardBadge,
  IntegrationsSectionStoresCardCommingSoonChip,
  IntegrationsSectionStoresCardButton,
  IntegrationsSectionStoresCardLogo,
} from './styles';

const IntegrationsSectionStoresCard = ({
  logo,
  commingSoon,
  onClick,
  companyTypePermissions,
}: IntegrationsSectionStoresCardProps): Nullable<ReactElement> => {
  const { user } = useAppSelector(selectAuth);

  const isEnabled = useMemo(
    () =>
      validatePartnerCompanyType(
        user?.company.companyTypeId as PartnerCompanyTypes,
        companyTypePermissions,
      ),
    [companyTypePermissions, user?.company.companyTypeId],
  );

  if (!isEnabled) return null;

  return (
    <IntegrationsSectionStoresCardBadge
      badgeContent={<IntegrationsSectionStoresCardCommingSoonChip />}
      invisible={!commingSoon}
    >
      <IntegrationsSectionStoresCardButton
        onClick={onClick}
        disabled={commingSoon}
      >
        <IntegrationsSectionStoresCardLogo src={logo.url} alt={logo.alt} />
      </IntegrationsSectionStoresCardButton>
    </IntegrationsSectionStoresCardBadge>
  );
};

export default memo(IntegrationsSectionStoresCard);
